var _rect, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeNoshow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 40,
    viewBox: "0 0 168 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 40,
    rx: 20,
    fill: "#D8CBBE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#645548",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 20,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 15.5V20L31.25 22"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 25.5,
    fill: "#55483B",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 600
  }, "Past booking")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeNoshow);
export default __webpack_public_path__ + "static/media/badge-noshow.78514309e56e851f1f57f01a58bff85f.svg";
export { ForwardRef as ReactComponent };